import React from "react";
import { Bar } from "react-chartjs-2";

const FacultyStudentRatioChartComponenet =  ({
    ratios = [],
    categories = [],
    title = "معدل أعضاء هيئة التدريس إلى الطلاب في الجامعات",
    color = "#E67E7E",
    height = 300,
  }) => {
    const data = {
      labels: categories,
      
      datasets: [
        {
          label: "نسبة هيئة التدريس إلى الطلاب",
          backgroundColor: color,
          borderWidth: 1,
          data: ratios,
        },
      ],
    };
  
    const options = {
      maintainAspectRatio: false,
      scales: {
        // yAxes: [
        //   {
        //     ticks: {
        //       beginAtZero: true,
        //       callback: (value) => `${value} : 1`,
        //     },
        //     scaleLabel: {
        //       display: true,
        //       labelString: "عدد أعضاء هيئة التدريس لكل طالب",
        //       fontFamily: "Cairo",
        //     },
        //   },
        // ],
        xAxes: [
          {
            barPercentage: 0.4,    
            categoryPercentage: 0.6,  
            ticks: {
              fontFamily: "Cairo",
            },
            scaleLabel: {
              display: true,
              labelString: "الجامعة",
              fontFamily: "Cairo",
            },
          },
        ],
      },
      legend: {
        labels: {
          fontFamily: "Cairo",
        },
      },
      tooltips: {
        callbacks: {
          label: function (tooltipItem) {
            return `النسبة: ${tooltipItem.yLabel.toFixed(2)} إلى 1`;
          },
        },
      },
    };
  
    return (
      <div className="card mt-4 p-3">
        <h5 className="mb-3" style={{ fontFamily: "Cairo" }}>{title}</h5>
        <div style={{ height }}>
          <Bar data={data} options={options} />
        </div>
      </div>
    );
  };

export default FacultyStudentRatioChartComponenet;
